import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import ResultBarChart from "./BarChart";
import ReactWordcloud from "react-wordcloud";
import { updateTabStates } from "../../../store/actions";
import { getSurveyResultsWithUserFromAPI, getSurveyResultsFromAPI } from "../../../services/surveyResultService";
import Button from "../../layout/button";
import { theme } from "antd";
export default function Results() {
  const dispatch = useDispatch();

  const themeMode = useSelector((state) => state.themeMode);
  // const currentSurveyResult = useSelector(state => state.currentSurveyResult);
  // const resultsCurrentQuestions = useSelector(state => state.resultsCurrentQuestions);
  const topMenuTabs = useSelector((state) => state.topMenuTabs);

  // const themeMode = topMenuTabs.tabs.find((tab) => tab.id === topMenuTabs.activeTab).states.themeMode;
  const currentSurvey = topMenuTabs.tabs.find(
    (tab) => tab.id === topMenuTabs.activeTab
  ).states.currentSurvey;
  const currentSurveyResult = topMenuTabs.tabs.find(
    (tab) => tab.id === topMenuTabs.activeTab
  ).states.currentSurveyResult;
  const resultsCurrentQuestions = topMenuTabs.tabs.find(
    (tab) => tab.id === topMenuTabs.activeTab
  ).states.resultsCurrentQuestions;
  const currentSurveyInsightData = topMenuTabs.tabs.find(
    (tab) => tab.id === topMenuTabs.activeTab
  ).states.currentSurveyInsightData;

  const [questions, setQuestions] = useState([]);
  const [filteredQuestions, setFilteredQuestions] = useState([]);
  const [infoText, setInfoText] = useState("");
  const [allSections, setAllSections] = useState([]);
  const [allPages, setAllPages] = useState([]);
  const [isOpenSectionMenu, setIsOpenSectionMenu] = useState(false);
  const [isOpenPageMenu, setIsOpenPageMenu] = useState(false);
  const [selectedSection, setSelectedSection] = useState("");
  const [selectedPage, setSelectedPage] = useState("");
  const userSelectRef = useRef(null);
  console.log("currentSurveyResults:", currentSurveyResult);

  function findFirstSentenceAndRest(text) {
    if (!text) {
      return {
        firstSentence: "",
        remainingText: "",
      };
    }
    const sentenceRegex = /(?<!\d)\.(?!\d)|[!?]/;

    const match = text.match(sentenceRegex);

    if (match) {
      const firstSentenceEndIndex = match.index + 1;
      const firstSentence = text.slice(0, firstSentenceEndIndex).trim();
      const remainingText = text.slice(firstSentenceEndIndex).trim();

      return {
        firstSentence: firstSentence,
        remainingText: remainingText,
      };
    }

    return {
      firstSentence: text.trim(),
      remainingText: "",
    };
  }

  useEffect(() => {
    let _newQuestions = [];
    currentSurveyResult?.forEach((res) => {
      console.log("res:", res["section"]);
      res["data"].forEach((data) => {
        if (data.type !== "text") {
          _newQuestions.push({
            section: res["section"],
            page: data["page"],
            type: data["type"],
            question: data["question"],
            rate: data["answers"],
            explanationHeader: "", //findFirstSentenceAndRest(data["comment"])["firstSentence"],
            explanationBody: "", //findFirstSentenceAndRest(data["comment"])["remainingText"]
          });
        }
      });
    });
    setQuestions(_newQuestions);
    setFilteredQuestions(_newQuestions);
    console.log("newQuestions:", _newQuestions);
  }, [currentSurveyResult]);

  const [currentIndex, setCurrentIndex] = useState(
    filteredQuestions?.findIndex(
      (q) => q.section === resultsCurrentQuestions?.name
    ) || 0
  );
  const [currentQuestion, setCurrentQuestion] = useState({});

  // useEffect(() => {
  //     if (filteredQuestions.length > 0) {
  //         setCurrentQuestion(filteredQuestions[currentIndex]);
  //         console.log('setCurrentQuestion...............', filteredQuestions[currentIndex]);
  //         setChartData(
  //             Object.entries(filteredQuestions[currentIndex].rate).map(
  //                 ([key, value]) => ({
  //                     label: value["answer"],
  //                     value: value["percentage"],
  //                 })
  //         ));
  //     }
  //     else {
  //         console.log('No questions available'); // Length 0 olduğunda aksiyon
  //         // Burada length 0 olduğunda yapılacak işlemi belirtebilirsiniz
  //         // Örneğin:
  //         setCurrentQuestion("");
  //         setChartData([]);
  //         setInfoText("Currently, there are no questions available")
  //     }
  // }, [filteredQuestions]);

  useEffect(() => {
    console.log("resultsCurrentQuestions:", resultsCurrentQuestions);
    console.log("filteredQuestions:", filteredQuestions);
    if (resultsCurrentQuestions) {
      if (resultsCurrentQuestions.type === "section") {
        const ind = filteredQuestions.findIndex(
          (q) => q.section === resultsCurrentQuestions.name
        );
        setCurrentIndex(ind);
      } else if (resultsCurrentQuestions.type === "page") {
        const ind = filteredQuestions.findIndex(
          (q) => q.page === resultsCurrentQuestions.name
        );
        setCurrentIndex(ind);
      } else if (resultsCurrentQuestions.type === "question") {
        const ind = filteredQuestions.findIndex(
          (q) => q.question === resultsCurrentQuestions.name
        );
        setCurrentIndex(ind);
      }
    }
    console.log("currentIndex:", currentIndex);
  }, [resultsCurrentQuestions, filteredQuestions]);

  useEffect(() => {
    console.log("currentIndex:", currentIndex);
    console.log("filteredQuestions:", filteredQuestions);
    if (filteredQuestions.length > 0) {
      setCurrentQuestion(filteredQuestions[currentIndex]);
      if (filteredQuestions[currentIndex]) {
        setChartData(
          Object.entries(filteredQuestions[currentIndex]?.rate)?.map(
            ([key, value]) => ({
              label: value["answer"],
              value: value["percentage"],
            })
          )
        );
      }
    }
  }, [currentIndex, filteredQuestions]);

  useEffect(() => {
    console.log("filteredQuestions güncellendi:", filteredQuestions);
    if (filteredQuestions.length > 0) {
      const sectionsData = [
        ...new Set(filteredQuestions.map((item) => item.section)),
      ];
      setAllSections(sectionsData);
      const pagesData = [
        ...new Set(filteredQuestions.map((item) => item.page)),
      ];
      setAllPages(pagesData);
      console.log("section&pagedata", sectionsData);
      setInfoText(""); // Eğer `filteredQuestions` dolarsa infoText'i sıfırla
    }
  }, [filteredQuestions]);

  useEffect(() => {
    console.log("currentQuestion:", currentQuestion);
    if (currentQuestion == undefined && filteredQuestions.length > 0) {
      setCurrentIndex(0);
      setCurrentQuestion(filteredQuestions[0]);
    }
  }, [currentQuestion]);

  const nextQuestion = () => {
    if (currentIndex < filteredQuestions.length - 1) {
      dispatch(
        updateTabStates(topMenuTabs.activeTab, "resultsCurrentQuestions", {
          name: filteredQuestions[currentIndex + 1].question,
          type: "question",
        })
      );
      setCurrentIndex(currentIndex + 1);
    }
  };

  const prevQuestion = () => {
    if (currentIndex > 0) {
      dispatch(
        updateTabStates(topMenuTabs.activeTab, "resultsCurrentQuestions", {
          name: filteredQuestions[currentIndex - 1].question,
          type: "question",
        })
      );
      setCurrentIndex(currentIndex - 1);
    }
  };

  const [chartData, setChartData] = useState(null);
  const navigateToSection = (section) => {
    setSelectedSection(section);
    const index = filteredQuestions.findIndex((q) => q.section === section);
    if (index !== -1) {
      setCurrentIndex(index);
    }
  };
  const navigateToPage = (page) => {
    setSelectedPage(page);
    const index = filteredQuestions.findIndex((q) => q.page === page);
    if (index !== -1) {
      setCurrentIndex(index);
    }
  };

  const navigateToQuestion = (questionId) => {
    console.log(questionId);
    const index = filteredQuestions.findIndex((q) => q.id === questionId);
    console.log(index);
    if (index !== -1) {
      setCurrentIndex(index);
    }
  };
  const handleClickOutside = (event, ref, setState) => {
    console.log("geldi",ref.current);
    if (ref.current && !ref.current.contains(event.target)) {
      console.log("yes");
      setState(false); // Eğer dışarıya tıklanırsa, ilgili modalı kapat
    }
  };
  const [isOpenMenu, setIsOpenMenu] = useState(false);
  useEffect(() => {
    if (isOpenMenu) {
      document.addEventListener("click", (event) =>
        handleClickOutside(event, userSelectRef, setIsOpenMenu)
      );
    }

    return () => {
      document.removeEventListener("click", (event) =>
        handleClickOutside(event, userSelectRef, setIsOpenMenu)
      );
    };
  }, [isOpenMenu]);
  // useEffect(() => {
  //     if (surveySection) {
  //         navigateToSection(surveySection);
  //     }
  // }, [surveySection]);

  // useEffect(() => {
  //     if (surveyPageName) {
  //         navigateToPage(surveyPageName);
  //     }
  // }, [surveyPageName]);

  // useEffect(() => {
  //     if (surveyQuestionId) {
  //         navigateToQuestion(surveyQuestionId);
  //     }
  // }, [surveyQuestionId]);
  const [tempQuestions, setTempQuestions] = useState([
    {
      section: "Section1",
      pages: [{ name: "Page1", questions: [{}] }],
    },
  ]);
  useEffect(() => {
    console.log("InfoText güncellendi:", infoText);
  }, [infoText]);

  const cloudRef = useRef(null);

  useEffect(() => {
    if (cloudRef.current) {
      console.log("WordCloud Yüklendi!");
    }
  }, []);

  const wordCloudOptions = {
    rotations: 2,
    rotationAngles: [-90, 0],
    fontSizes: [20, 60], // Minimum ve maksimum font boyutu
  };

  const callbacks = {
    // getWordColor: word => word.value > 50 ? "blue" : "red",
    // onWordClick: (word, event) => console.log("Word clicked:", word.text),
    // onWordMouseOver: (word, event) => console.log("Mouse over:", word.text),
    // onWordMouseOut: (word, event) => console.log("Mouse out:", word.text),
    getWordTooltip: (word) => `${word.text} (${word.value})`,
  };


  async function getResults() {
    try {
      dispatch(updateTabStates(topMenuTabs.activeTab, "pageIsLoading", true));
      // dispatch(updateTabStates(topMenuTabs.activeTab, 'currentSurveyResult', []));
      const result = await getSurveyResultsFromAPI(currentSurvey.ID);
      console.log("Results:", result);
      dispatch(
        updateTabStates(
          topMenuTabs.activeTab,
          "currentSurveyResult",
          result["results"]
        )
      );
      dispatch(updateTabStates(topMenuTabs.activeTab, "pageIsLoading", false));
    } catch (error) {
      dispatch(updateTabStates(topMenuTabs.activeTab, "pageIsLoading", false));
      // if (error.message === "Request failed with status code 401") {
      //   setSelectedFunction("getResults");
      //   checkAuth();
      // }
    }
  }

  return infoText.length === 0 ? (
    <div
      className={`flex flex-col items-center justify-start w-full p-4 px-14 ${
        themeMode === "dark"
          ? "bg-[#1a1a28] text-white"
          : "bg-[#fbfbfc] text-black"
      }`}
    >
      {currentQuestion?.type !== undefined && (
        <div
          className=" flex flex-row w-full justify-between items-center"
         
        >
          {/* <div className="flex flex-col"  ref={userSelectRef}>
            <button
              onClick={() => {
                setIsOpenMenu(!isOpenMenu);
              }}
              className={`hulyButton font-medium-14 h-[1.5rem] lg:h-[2rem] w-64 px-2 border rounded-[0.375rem] cursor-pointer flex justify-between  items-center gap-2 ${
                themeMode === "dark"
                  ? "border-[#d1d5de0a] bg-[#d1d5de0d] hover:bg-[#d1d5de0a] hover:text-[#fff] text-white-8"
                  : "border-[#1725471a] bg-[#1725470d] hover:bg-[#1725471a] hover:text-[#000] text-black-8"
              }`}
            >
              <div className="truncate">
                {selectedUser
                  ? selectedUser.first_name + " " + selectedUser.last_name
                  : "Select an user"}
              </div>
              {selectedUser?(
                 <div
                 className={`btn-icon  ${themeMode === "dark" ? "text-white-8" : "text-black-8"
                   }`} onClick={(event) => {
                    event.stopPropagation(); // Parent button'a click eventinin gitmesini engeller
                    setSelectedUser(null);
                    getResults();
                  }}
               >
                 <svg
                   className="svg-small w-[.8rem] h-[.8rem] mr-1"
                   fill="currentColor"
                   viewBox="0 0 16 16"
                   xmlns="http://www.w3.org/2000/svg"
                 >
                   <path d="M8.7,8l4.6-4.6c0.2-0.2,0.2-0.5,0-0.7s-0.5-0.2-0.7,0L8,7.3L3.4,2.6c-0.2-0.2-0.5-0.2-0.7,0s-0.2,0.5,0,0.7L7.3,8l-4.6,4.6c-0.2,0.2-0.2,0.5,0,0.7c0.1,0.1,0.2,0.1,0.4,0.1s0.3,0,0.4-0.1L8,8.7l4.6,4.6c0.1,0.1,0.2,0.1,0.4,0.1s0.3,0,0.4-0.1c0.2-0.2,0.2-0.5,0-0.7L8.7,8z"></path>
                 </svg>
               </div>
              ):(  <svg
                className="w-5 h-5 ml-2 -mr-1"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
                aria-hidden="true"
              >
                <path
                  fillRule="evenodd"
                  d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                  clipRule="evenodd"
                />
              </svg>)}
            
            </button>
          </div>
          {isOpenMenu && (
            <div
              className={`absolute left-0 z-[99999999]  w-64 top-13  ${
                currentSurvey?.survey_users?.length <= 6
                  ? "h-auto"
                  : "h-[250px]"
              } overflow-y-scroll  origin-top-right rounded-md shadow-2xl ring-1 ring-black/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in  border-solid border-[1px] ${
                themeMode === "dark"
                  ? " bg-[#2a2939] border-white-09 shadow-theme-popup-shadow "
                  : "bg-[#FFFFFF] border-black-09 shadow-black-2-shadow"
              }`}
            >
              <div className="py-1">
                {currentSurvey?.survey_users?.map((user) => (
                  <button
                    key={user.user_id}
                    className={`flex-shrink-0 flex justify-between px-2 py-1 min-w-0 min-h-[2.25rem] text-left rounded-md cursor-pointer ${
                      themeMode === "dark"
                        ? "hover:bg-[#333240] text-white"
                        : "hover:bg-[#EBEBEB] text-black"
                    }`}
                    onClick={() => {
                      onchangeUser(user);
                    }}
                  >
                    {user.first_name} {user.last_name} - {user.email}
                  </button>
                ))}
              </div>
            </div>
          )} */}
          <div className="flex gap-4 mb-8 justify-end text-end w-3/4 ">
          <Button text="Previous" onClick={prevQuestion} disabled={currentIndex === 0}  themeMode={themeMode}/>
            <Button text="Next" onClick={nextQuestion} disabled={currentIndex === filteredQuestions.length - 1} />

            {/* <button
              onClick={nextQuestion}
              disabled={currentIndex === filteredQuestions.length - 1}
              className={` min-w-[5rem] flex-shrink-0 px-3 py-2 flex justify-center align-center border-solid border rounded-[0.375rem] h-[2.25rem]      disabled:cursor-not-allowed text-[#fff] border-white-09 cursor-pointer hover:bg-[#3575DE] bg-[#205DC2] ${
                themeMode === "dark"
                  ? "text-[#fff] border-white-09 cursor-pointer hover:bg-[#3575DE] bg-[#205DC2] disabled:text-white-4  disabled:bg-white-02"
                  : "text-[#fff] border-white-09 cursor-pointer hover:bg-[#3575DE] bg-[#205DC2] disabled:text-black-4  disabled:bg-black-06"
              }`}
            >
              {" "}
              Next
            </button> */}
          </div>
        </div>
      )}
      <div className="w-full text-start">
        <h1
          className={`text-[16px] font-bold mb-4 ${
            themeMode === "dark"
              ? "text-[#D9D9D9]"
              : "text-black text-opacity-60"
          }`}
        >
          {currentQuestion?.section ? currentQuestion?.section + " > " : ""}
          {currentQuestion?.page}
        </h1>
        <p
          className={`text-[24px] mb-6 text-left  ${
            themeMode === "dark"
              ? "text-[#F5F2F2]"
              : "text-black text-opacity-60"
          }`}
        >
          {currentQuestion?.question}
        </p>
        <div className="text-left w-3/4">
          {chartData &&
            currentQuestion?.type !== "comment" &&
            currentQuestion?.type !== "text" &&
            currentQuestion?.type !== "rating" && (
              <ResultBarChart data={chartData} xKey="label" yKey="value" />
            )}
          {currentQuestion?.type === "comment" && (
            <div>
              <ReactWordcloud
                words={filteredQuestions[currentIndex]?.rate}
                options={wordCloudOptions}
                callbacks={callbacks}
                ref={cloudRef}
                // size={[600,400]}
              />
            </div>
          )}
          {currentQuestion?.type === "rating" && (
            <ResultBarChart
              data={
                chartData?.map((x) => {
                  if (x && x.label) {
                    // Eğer 'x' ve 'label' mevcutsa, işlemi yap
                    x["label"] = x["label"] + " Star";
                  }
                  return x; // Sonuç olarak her 'x' objesini döndür
                }) || []
              }
              xKey="label"
              yKey="value"
            />
          )}
        </div>
      </div>
      {currentQuestion?.type !== undefined && 
        (currentSurvey?.content?.pages.find(p => p.type === "demographics")?.name !== currentQuestion?.section) &&
        (currentSurveyInsightData?.report_detail?.question_comments?.find((x) => x.question == currentQuestion?.question)?.comment !== undefined) && (
        <div className="w-full text-start  mt-4 pb-4 flex flex-col justify-start">
          <div
            className={`shadow-md rounded-lg pt-2 px-0 pb-4  min-w-[150px] w-3/4 h-auto border-l border-l-[4px] border-l-[#596877] rounded-l-none
                      ${
                        themeMode === "dark"
                          ? "bg-[#000000] hover:bg-[#282834] text-white cursor-pointer "
                          : "bg-white text-gray-800 cursor-pointer"
                      }
                        
                      `}
          >
            <div className="p-4 py-1 rounded-lg space-y-8">
              <div className="flex justify-between items-center mb-3">
                <span
                  className={`size-5 whitespace-nowrap text-sm sm:text-[20px] font-bold ${
                    themeMode === "dark" ? "text-[#FFFFFF]" : "text-gray-800"
                  }`}
                >
                  Review
                </span>
              </div>
              <div className="flex justify-start flex-col space-y-2 mb-3 border py-4 divide-y">
                <div className="flex justify-start space-x-16 items-center px-2">
                  <div className="flex justify-start space-x-2 items-center">
                    <span className="rounded-full w-8 h-8 bg-[#8AAFEA] flex flex-shrink-0 text-center justify-center items-center text-xl text-black font-bold">
                      {" "}
                      1
                    </span>
                    <p
                      className={`text-md  font-bold ${
                        themeMode === "dark"
                          ? "text-[#FFFFFF]"
                          : "text-gray-800"
                      }`}
                    >
                      {
                        currentSurveyInsightData?.report_detail?.question_comments
                          ?.find((x) => x.question == currentQuestion?.question)
                          ?.comment?.split(/(?<!\d)\./)[0]
                      }
                      .
                    </p>
                  </div>
                </div>
                <div className="flex  space-x-16 items-center pt-2 px-2">
                  <div className="flex justify-start space-x-2 items-center">
                    <span className="rounded-full w-8 h-8 bg-[#8AAFEA] flex text-center justify-center items-center text-xl text-black font-bold">
                      {" "}
                      2
                    </span>
                    <p
                      className={`text-md  font-bold ${
                        themeMode === "dark"
                          ? "text-[#FFFFFF]"
                          : "text-gray-800"
                      }`}
                    >
                      {
                        currentSurveyInsightData?.report_detail?.question_comments
                          ?.find((x) => x.question == currentQuestion?.question)
                          ?.comment?.split(/(?<!\d)\./)[1]
                      }
                      .
                    </p>
                  </div>
                </div>
                <div className="flex justify-start space-x-16 items-center pt-2 px-2">
                  <div className="flex justify-start space-x-2 items-center">
                    <span className="rounded-full w-8 h-8 bg-[#8AAFEA] flex text-center justify-center items-center text-xl text-black font-bold">
                      {" "}
                      3
                    </span>
                    <p
                      className={`text-md  font-bold ${
                        themeMode === "dark"
                          ? "text-[#FFFFFF]"
                          : "text-gray-800"
                      }`}
                    >
                      {
                        currentSurveyInsightData?.report_detail?.question_comments
                          ?.find((x) => x.question == currentQuestion?.question)
                          ?.comment?.split(/(?<!\d)\./)[2]
                      }
                      .
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  ) : (
    <div
      className={`flex flex-col items-center justify-center w-full h-full p-4 ${
        themeMode === "dark"
          ? "bg-[#1a1a28] text-white"
          : "bg-[#fbfbfc] text-black"
      }`}
    >
      <div
        className={`${
          themeMode === "dark"
            ? "text-white text-opacity-60"
            : "text-black text-opacity-60"
        } text-sm`}
      >
        {infoText}
      </div>{" "}
    </div>
  );
}
